import React from 'react';
import { Menu, MenuItem, ListItem, ListItemText } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { routes } from 'app/routes/route-list';

export class DevFormRoutes extends React.Component<any, any> {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  render() {
    const { anchorEl } = this.state;
    return (
      <React.Fragment>
        <ListItem button onClick={(e) => this.handleClick(e)}>
          <ListItemText primary="Forms" />
        </ListItem>
        <Menu
          anchorEl = {anchorEl}
          open     = {Boolean(anchorEl)}
          style    = {{ zIndex: 9999 }}
          onClose  = {this.handleClose}
        >
          <Link to={routes.purchase}>
            <MenuItem onClick={this.handleClose}>Purchase</MenuItem>
          </Link>
          <Link to={routes.refinance}>
            <MenuItem onClick={this.handleClose}>Refinance</MenuItem>
          </Link>
          <Link to={routes.application}>
            <MenuItem onClick={this.handleClose}>Application Landing Page</MenuItem>
          </Link>
          <Link to={routes.homeEquity}>
            <MenuItem onClick={this.handleClose}>Home Equity</MenuItem>
          </Link>
          <Link to={routes.applicationHomeEquity}>
            <MenuItem onClick={this.handleClose}>Home Equity Application</MenuItem>
          </Link>
          <Link to={routes.branch}>
            <MenuItem onClick={this.handleClose}>Branch</MenuItem>
          </Link>
          <Link to={routes.scheduleAppointment}>
            <MenuItem onClick={this.handleClose}>Schedule Appointment</MenuItem>
          </Link>
          <Link to={routes.autoPrequal}>
            <MenuItem onClick={this.handleClose}>Auto Pre-Qualification</MenuItem>
          </Link>
          <Link to={`/resume/prequal-renew/f286613d-aa79-43ba-b6b5-94c540da6d55/32acc5d11dcd5bc7a726683afc6fafbe5a150fe8`}>
            <MenuItem onClick={this.handleClose}>Auto Pre-Qualification (Renew)</MenuItem>
          </Link>
          <Link to={`/resume/prequal/f286613d-aa79-43ba-b6b5-94c540da6d55/32acc5d11dcd5bc7a726683afc6fafbe5a150fe8`}>
            <MenuItem onClick={this.handleClose}>Auto Pre-Qualification (Edit Letter)</MenuItem>
          </Link>
          <Link to={routes.broker}>
            <MenuItem onClick={this.handleClose}>Broker Landing Page</MenuItem>
          </Link>
        </Menu>
      </React.Fragment>
    );
  }
}
